import api from '../../api'

/**
 * Execute a Discover-page repository listing.
 *
 * This is a filtered, sorted listing rather than a relevance-ranked search:
 * there is no query text, only a subject and an order.
 *
 * Sorting used to be expressed by picking one of three Algolia replica indexes
 * and is now a `sort` parameter. The per-subject filter string callers used to
 * assemble has gone too — the API resolves a subject name to its filter
 * server-side, which keeps environment-specific subject ids out of the bundle.
 *
 * @param {Object} params
 * @param {string} params.subject Discover subject name, e.g. 'earlyMath'.
 * @param {string} params.sort    'latest', 'popular' or 'rated'.
 * @param {number} params.limit   Maximum number of hits to return.
 * @param {number} [params.page]  Zero-based page number.
 * @returns {Promise<Object[]>} Resolves with the array of hit objects.
 */
export function searchDiscoverRepos({
  subject, sort, limit, page = 0,
}) {
  return api.fetch('/search/discover/repos', {
    subject, sort, limit, page,
  }).then(({ hits }) => hits)
}
